'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["aria-label", "aria-labelledby"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { screenXsMax } from '@spotify-internal/encore-foundation';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.js";
import { cssSpacing } from "../../styles/index.js";
import { deprecatedOverlayDirections } from "../../styles/mixins/overlays-deprecated.js";
import { ButtonTertiary } from "../ButtonTertiary/index.js";
import { IconHelpCircle } from "../Icon/icons/IconHelpCircle/index.js";
import { PopoverTrigger } from "../PopoverTrigger/index.js";
import styled from "../../styled-components.js";
var StyledButtonTertiary = styled(ButtonTertiary).withConfig({
  displayName: "FormPopoverTrigger__StyledButtonTertiary",
  componentId: "sc-7ymulv-0"
})(["@media (max-width:", "){padding:", ";margin:calc(-1 * ", ");}"], screenXsMax, cssSpacing('tighter-4', '4px'), cssSpacing('tighter-4', '4px'));
var FormPopoverTriggerComponent = function FormPopoverTriggerComponent(_ref) {
  var ariaLabel = _ref['aria-label'],
    ariaLabelledby = _ref['aria-labelledby'],
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(PopoverTrigger, Object.assign({}, props, {
    "data-encore-id": ENCORE_DATA_IDS.FormPopoverTrigger
  }), /*#__PURE__*/React.createElement(StyledButtonTertiary, {
    type: "button",
    condensedAll: true,
    buttonSize: "sm",
    iconOnly: IconHelpCircle,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby
  }));
};
var formPopoverTriggerHelpers = _objectSpread({}, deprecatedOverlayDirections);

/**
 * The FormPopoverTrigger will trigger a Popover from a form element such as a specific form field, to provide additional context.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-formpopovertrigger--docs) |
 * [Encore site](https://encore.spotify.net/web/components/form#form-popover-trigger) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormPopoverTrigger) |
 */
export var FormPopoverTrigger = Object.assign(FormPopoverTriggerComponent, formPopoverTriggerHelpers);